"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var moment_1 = tslib_1.__importDefault(require("moment"));
var CalendarPart_1 = tslib_1.__importDefault(require("../calendar/CalendarPart"));
var controlled_1 = require("../form/controlled");
var input_1 = require("../input");
var TimeTable_1 = require("./TimeTable");
var button_1 = require("../button");
var i18n_1 = require("../i18n");
var dropdown_1 = require("../dropdown");
var util_1 = require("./util");
var TimeRangePicker_1 = require("./TimeRangePicker");
var use_default_1 = require("../_util/use-default");
var Popover_1 = require("../popover/Popover");
var util_2 = require("../datepicker/util");
var config_context_1 = require("../_util/config-context");
var noop_1 = require("../_util/noop");
var key_map_1 = require("../_util/key-map");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var merge_event_props_1 = require("../_util/merge-event-props");
var icon_1 = require("../icon");
exports.TimePicker = forward_ref_with_statics_1.forwardRefWithStatics(function TimePicker(props, ref) {
    var classPrefix = config_context_1.useConfig().classPrefix;
    var t = i18n_1.useTranslation(moment_1.default);
    var _a = controlled_1.useDefaultValue(props), value = _a.value, onChange = _a.onChange, _b = _a.format, format = _b === void 0 ? "HH:mm:ss" : _b, _c = _a.placeholder, placeholder = _c === void 0 ? t.selectTime : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.defaultOpen, defaultOpen = _e === void 0 ? false : _e, open = _a.open, _f = _a.onOpenChange, onOpenChange = _f === void 0 ? noop_1.noop : _f, _g = _a.onInputValueChange, onInputValueChange = _g === void 0 ? noop_1.noop : _g, _h = _a.placement, placement = _h === void 0 ? "bottom-start" : _h, _j = _a.placementOffset, placementOffset = _j === void 0 ? 5 : _j, _k = _a.closeOnScroll, closeOnScroll = _k === void 0 ? true : _k, escapeWithReference = _a.escapeWithReference, popupContainer = _a.popupContainer, clearable = _a.clearable, overlayClassName = _a.overlayClassName, overlayStyle = _a.overlayStyle, className = _a.className, style = _a.style;
    var _l = tslib_1.__read(react_1.useState(false), 2), hover = _l[0], setHover = _l[1];
    var _m = tslib_1.__read(react_1.useState(value), 2), curValue = _m[0], setCurValue = _m[1];
    var _o = tslib_1.__read(use_default_1.useDefault(open, defaultOpen, onOpenChange), 2), active = _o[0], setActive = _o[1];
    react_1.useEffect(function () {
        setCurValue(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);
    var getInputValue = react_1.useCallback(function (value) {
        return moment_1.default.isMoment(value)
            ? value.locale(t.locale).format(format)
            : "";
    }, [t.locale, format]);
    var _p = tslib_1.__read(react_1.useState(getInputValue(curValue)), 2), inputValue = _p[0], setInputValue = _p[1];
    var syncInputValue = react_1.useCallback(function (value) {
        var inputValue = getInputValue(value);
        setInputValue(inputValue);
        onInputValueChange(inputValue, { valid: true });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getInputValue]);
    react_1.useEffect(function () {
        setCurValue(value);
        syncInputValue(value);
    }, [format, getInputValue, syncInputValue, value]);
    function handleInputChange(content) {
        setInputValue(content);
        // 格式校验
        var value = moment_1.default(content, format, true);
        if (!value.isValid()) {
            onInputValueChange(content, { valid: false });
            return;
        }
        var valid = util_1.isValidTimeValue(value, props);
        if (valid) {
            setCurValue(value);
        }
        onInputValueChange(content, { valid: valid });
    }
    function handleKeyDown(event) {
        if (!active) {
            handleOpen();
            return;
        }
        switch (event.key) {
            case key_map_1.KeyMap.Enter:
                handleOk(event);
                break;
            case key_map_1.KeyMap.Esc:
                handleClose();
                break;
        }
    }
    function handleSelectChange(value) {
        syncInputValue(value);
        setCurValue(value);
    }
    function handleOk(event) {
        if (!curValue) {
            return;
        }
        onChange(curValue, { event: event });
        handleClose();
    }
    function handleOpen() {
        if (disabled) {
            return;
        }
        setActive(true);
    }
    function handleClose() {
        syncInputValue(value);
        setActive(false);
    }
    return (react_1.default.createElement(Popover_1.Popover, { trigger: [
            util_2.DatePickerTrigger,
            { onOpen: handleOpen, onClose: handleClose },
        ], visible: active, onVisibleChange: setActive, placement: placement, placementOffset: placementOffset, closeOnScroll: closeOnScroll, escapeWithReference: escapeWithReference, popupContainer: popupContainer, overlayClassName: overlayClassName, overlayStyle: overlayStyle, overlay: react_1.default.createElement(dropdown_1.DropdownBox, { preventMouseDown: true },
            react_1.default.createElement(CalendarPart_1.default.Panel, { timeMode: true },
                react_1.default.createElement(CalendarPart_1.default.Body, null,
                    react_1.default.createElement(TimeTable_1.TimeTable, tslib_1.__assign({}, props, { value: curValue, onChange: handleSelectChange }))),
                react_1.default.createElement(CalendarPart_1.default.Footer, { right: react_1.default.createElement(button_1.Button, { type: "primary", htmlType: "button", onClick: handleOk, disabled: !curValue }, t.okText) }))) },
        react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-timepicker", className), style: style }, merge_event_props_1.mergeEventProps(props)),
            react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-timepicker__input", {
                    "is-hover": hover && value && clearable,
                }), onMouseEnter: function () { return setHover(true); }, onMouseLeave: function () { return setHover(false); } },
                react_1.default.createElement(input_1.Input, { maxLength: 8, disabled: disabled, placeholder: placeholder, value: inputValue, onChange: handleInputChange, onKeyDown: handleKeyDown, onClick: function (event) {
                        if (active) {
                            event.stopPropagation();
                        }
                    } }),
                clearable && !disabled && (react_1.default.createElement(icon_1.Icon, { type: "dismiss", onClick: function (event) {
                        event.stopPropagation();
                        onChange(null, { event: event });
                    } }))))));
}, {
    defaultLabelAlign: "middle",
    RangePicker: TimeRangePicker_1.TimeRangePicker,
});
exports.TimePicker.displayName = "TimePicker";
//# sourceMappingURL=TimePicker.js.map